import { useAuth0 } from "@auth0/auth0-react";
import Popover from "@material-ui/core/Popover";
import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { CircularProgress } from "@mui/material";
import PreSchoolService from "Lib/API/PreSchool";
import React, { useState } from "react";
import { toastr } from "react-redux-toastr";
import "./style.scss";

const useStyles = makeStyles((theme) => ({
  popover: {
    "& .MuiPopover-paper": {
      left: "68% !important",
    },
    "@media (min-width: 1366px)": {
      "& .MuiPopover-paper": {
        left: "67% !important",
      },
    },
    "@media (min-width: 1517px)": {
      "& .MuiPopover-paper": {
        left: "70% !important",
      },
    },
    "@media (min-width: 1707px)": {
      "& .MuiPopover-paper": {
        left: "72.5% !important",
      },
    },
    "@media (min-width: 1821px)": {
      "& .MuiPopover-paper": {
        left: "73.5% !important",
      },
    },
    "@media (min-width: 2049px)": {
      "& .MuiPopover-paper": {
        left: "76% !important",
      },
    },
  },
}));

export default function ParticipantPopOver({
  onSendPaymentLinkClick,
  onEditClick,
  onParticipantDeleteClick,
  onMoveToClick,
  setClassMovedId,
  setConfirmDialog,
  onEditViewClick,
  onViewClick,
  style,
  sentInvitation,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const [list, setList] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const classes = useStyles();

  async function getClassesList() {
    if (list.length > 0) return;
    try {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.getAllClasses(token);
      setList(result?.payload?.data);
      setCount(result?.payload?.pagination?.count);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="participantPopOver_container">
      <div>
        <MoreHorizIcon
          color="primary"
          className="more__hor"
          onClick={handleClick}
        />
      </div>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={() => setAnchorEl(null)}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          color: "red",
        }}
      >
        <div
          className="participantPopOver"
          style={{ ...style, width: "141px" }}
        >
          {sentInvitation && (
            <div
              className="participantPopOver__action"
              onClick={() => {
                sentInvitation();
                setAnchorEl(null);
              }}
            >
              Resend Invitation
            </div>
          )}
          {onEditViewClick && (
            <div
              className="participantPopOver__action"
              onClick={() => {
                onEditViewClick();
                setAnchorEl(null);
              }}
            >
              View / Edit
            </div>
          )}
          {onViewClick && (
            <div
              className="participantPopOver__action"
              onClick={() => {
                onViewClick();
                setAnchorEl(null);
              }}
            >
              View
            </div>
          )}
          {onSendPaymentLinkClick && (
            <div
              className="participantPopOver__action"
              onClick={() => {
                onSendPaymentLinkClick();
                setAnchorEl(null);
              }}
            >
              Send Payment Link
            </div>
          )}
          {onEditClick && (
            <div
              onClick={() => {
                onEditClick();
                setAnchorEl(null);
              }}
              className="participantPopOver__action"
            >
              Edit
            </div>
          )}
          {onParticipantDeleteClick && (
            <div
              className="participantPopOver__action"
              onClick={() => {
                onParticipantDeleteClick();
                setAnchorEl(null);
              }}
            >
              Delete
            </div>
          )}
          {onMoveToClick && (
            <div
              className="participantPopOver__action d-flex justify-content-between align-items-center"
              onClick={(e) => {
                handleClick2(e);
                onMoveToClick();
                getClassesList();
              }}
              style={{
                borderTop: "1px solid #E5E5E5",
                height: "40px",
              }}
            >
              Move To <KeyboardArrowRightIcon fontSize="small" />
            </div>
          )}
        </div>
      </Popover>
      <Popover
        // className={classes.popover}
        open={Boolean(anchorEl2)}
        anchorEl={anchorEl2}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={() => {
          setAnchorEl2(null);
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          color: "red",
        }}
      >
        <div className="class_list_popover">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center h-100">
              <CircularProgress size={20} />
            </div>
          ) : list?.length === 0 ? (
            <div className="d-flex justify-content-center align-items-center h-100">
              No classes found
            </div>
          ) : (
            list?.map((item, index) => (
              <div
                key={index}
                className="class_list_popover__action"
                onClick={() => {
                  setClassMovedId(item?._id);
                  setConfirmDialog(true);
                }}
              >
                {item?.class_name}
              </div>
            ))
          )}
        </div>
      </Popover>
    </div>
  );
}
